import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmtDate } from "@/lib/api";
import { PageHead, StatusBadge } from "@/pages/AppLayout";
import { Bell, ArrowUpRight } from "lucide-react";

const TABS = ["overdue", "upcoming", "all"];

export default function Reminders() {
  const [rems, setRems] = useState(null);
  const [tab, setTab] = useState("overdue");

  useEffect(() => { api.get("/reminders").then(({ data }) => setRems(data)); }, []);

  const shown = useMemo(() => {
    if (!rems) return [];
    if (tab === "all") return rems;
    return rems.filter((r) => r.status === tab);
  }, [rems, tab]);

  const counts = useMemo(() => ({
    overdue: rems?.filter((r) => r.status === "overdue").length || 0,
    upcoming: rems?.filter((r) => r.status === "upcoming").length || 0,
    all: rems?.length || 0,
  }), [rems]);

  return (
    <div className="p-5 md:p-10 pb-24" data-testid="reminders-page">
      <PageHead title="Reminders" sub="Everything due across the fleet." />

      <div className="flex gap-2 mb-6">
        {TABS.map((t) => (
          <button key={t} onClick={() => setTab(t)} className={`h-12 px-5 font-head font-600 uppercase text-sm tracking-wide border transition-colors flex items-center gap-2 ${tab === t ? "bg-[#FFB800] text-black border-[#FFB800]" : "card text-[#94A3B8] border-white/20 hover:text-white"}`} data-testid={`rem-tab-${t}`}>
            {t} <span className="font-mono text-xs opacity-70">{counts[t]}</span>
          </button>
        ))}
      </div>

      {rems === null ? <p className="font-head text-[#FFB800] uppercase tracking-widest">Loading…</p> : shown.length === 0 ? (
        <div className="card p-12 text-center">
          <Bell className="w-10 h-10 text-[#94A3B8] mx-auto mb-3" />
          <p className="font-body text-[#94A3B8]">Nothing {tab === "all" ? "here yet" : tab}. You're on top of it.</p>
        </div>
      ) : (
        <div className="card divide-y divide-white/10">
          {shown.map((r) => (
            <Link to={`/machines/${r.machine_id}`} key={r.id} className="flex items-center gap-4 px-5 py-4 hover:bg-[#23262F] transition-colors" data-testid={`rem-row-${r.id}`}>
              <div className="flex-1 min-w-0">
                <p className="font-head font-700 text-lg uppercase truncate">{r.title}</p>
                <p className="font-mono text-xs text-[#94A3B8]">{r.machine_name} · {r.category.replace("_", " ")} · due {fmtDate(r.due_date)}</p>
              </div>
              <StatusBadge status={r.status} />
              <ArrowUpRight className="w-4 h-4 text-[#94A3B8]" />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
